import { Path } from './Path';

let FirebaseEncode = {
  lookup: {
    '.': '&period;',
    $: '&dollar;',
    '#': '&hash;',
    '[': '&lbracket;',
    ']': '&rbracket;',
    '/': '&slash;'
  },
  encode: function (string) {
    if (string) {
      for (var key in FirebaseEncode.lookup) {
        string = string.replace(new RegExp('\\' + key, 'g'), FirebaseEncode.lookup[key]);
      }
    }
    return string;
  },
  decode: function (string) {
    if (string) {
      for (var key in FirebaseEncode.lookup) {
        string = string.replace(new RegExp(FirebaseEncode.lookup[key], 'g'), key);
      }
    }
    return string;
  },
  decodeKeys: function (obj) {
    let temp = Array.isArray(obj) ? [] : {};
    for (let key in obj) temp[FirebaseEncode.decode(key)] = Path.isObject(obj[key]) ? FirebaseEncode.decodeKeys(obj[key]) : obj[key];
    return temp;
  },
  encodeKeys: function (obj) {
    let temp = Array.isArray(obj) ? [] : {};
    for (let key in obj) temp[FirebaseEncode.encode(key)] = Path.isObject(obj[key]) ? FirebaseEncode.encodeKeys(obj[key]) : obj[key];
    return temp;
  }
};

export { FirebaseEncode };
